'use strict';

class SearchResults extends HTMLUListElement {
    static get observedAttributes() {
        return ['results'];
    }

    constructor() {
        super();
        this.baseURL = this.getAttribute('base-url');
        this.template = this.template.bind(this);
    }

    template(suggestion) {
        const separator = this.baseURL.includes('?') ? '&' : '?';
        return `
            <li class="search-suggestions__item">
                <a class="search-suggestions__link" href="${this.baseURL}${separator}q=${suggestion.suggestion}">${suggestion.formatted}</a>
            </li>
        `;
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        if (oldValue === newValue) return;

        this.innerHTML = '';
        const links = JSON.parse(newValue).map(this.template);
        this.insertAdjacentHTML('afterbegin', links.join(''));
    }
}

export default SearchResults;

customElements.define('vz-search-results', SearchResults, { extends: 'ul' });
